import { getBaseUrl, getCareerCaptchaKey } from '../../../constant';
import { FORM_ACTION_TYPE } from '../../constants';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import { ACTIONS, OPEN_POSITION_ENDPOINT } from './constant';

export function formateObject(name, value) {
  if (name === 'name') {
    return { type: ACTIONS.VALIDATE_NAME, payload: { value } };
  }
  if (name === 'email') {
    return { type: ACTIONS.VALIDATE_EMAIL, payload: { value } };
  }
  if (name === 'phone-number') {
    return { type: ACTIONS.VALIDATE_PHONE, payload: { value } };
  }
  if (name === 'current-location') {
    return { type: ACTIONS.CURRENT_LOCATION, payload: { value } };
  }
  if (name === 'linkedIn-link') {
    return { type: ACTIONS.LINKED_IN_LINK, payload: { value } };
  }
  if (name === 'notice-period') {
    return { type: ACTIONS.NOTICE_PERIOD, payload: { value } };
  }
  if (name === 'current-salary') {
    return { type: ACTIONS.CURRENT_SALARY, payload: { value } };
  }
  if (name === 'expected-salary') {
    return { type: ACTIONS.EXPECTED_SALARY, payload: { value } };
  }

  return {};
}

/**
 * utility function for handle submit application
 * @param {Function} setApplied
 * @param {Function} setFormSubmit
 * @param {Function} setError
 * @param {Function} setIsServerError
 * @param {String} recaptcha
 * @param {Object} reqBody
 */
export function postData(
  setApplied,
  setFormSubmit,
  setError,
  recaptchaToken,
  setIsServerError,
  reqBody,
) {
  fetchWithAuth(`${getBaseUrl()}/website/v2/applications`, {
    method: 'POST',
    headers: {
      'True-Client-Ip': '127.0.0.1',
      'X-Correlation-ID': 1,
      'X-Zopsmart-Tenant': 'Zopsmart',
      'g-recaptcha-response': recaptchaToken,
      'g-recaptcha-key': `${getCareerCaptchaKey()}`,
      'g-recaptcha-action': `${FORM_ACTION_TYPE}`,
    },
    body: JSON.stringify(reqBody),
  })
    .then((response) => {
      if (response.ok)
        setApplied((prevValues) => {
          return { ...prevValues, status: true };
        });
      else
        setError((prevValues) => {
          return { ...prevValues, status: true };
        });
      setFormSubmit(false);
      if (response.status === 401) return Promise.reject({ isAuthError: true });
      if (response.status < 500) return response.json();
      return Promise.reject(response);
    })
    .then((message) => {
      if (message.errors) {
        setError((prevValues) => {
          return {
            ...prevValues,
            status: true,
            message: message.errors[0].reason,
          };
        });
      } else {
        setApplied((prevValues) => {
          return {
            ...prevValues,
            status: true,
            message: message.data?.message,
          };
        });
      }
    })
    .catch((error) => {
      if (error?.isAuthError) return;
      setIsServerError(true);
      setFormSubmit(false);
    });
}

/**
 * utility function for get position data
 * @param {Function} setPositionDescription
 * @param {Function} setPositionDescriptionStatus
 * @param {Number} id
 */
function getHiringMotionBaseUrl() {
  const hostname = window.location.hostname;
  if (hostname === 'staging.zopsmart.com') return 'https://api.staging.hiringmotion.com';
  if (hostname === 'zopsmart.com' || hostname === 'www.zopsmart.com')
    return 'https://api.hiringmotion.com';
  return getBaseUrl();
}

export function getData(setPositionDescription, setPositionDescriptionStatus, id) {
  fetchWithAuth(`${getHiringMotionBaseUrl()}${OPEN_POSITION_ENDPOINT}/${id}`, {
    method: 'GET',
    headers: {
      'True-Client-Ip': '127.0.0.1',
      'X-Correlation-ID': 1,
      'X-Zopsmart-Tenant': 'Zopsmart',
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response);
    })
    .then((position) => {
      setPositionDescription(position);
      setPositionDescriptionStatus(true);
    })
    .catch((error) => {
      setPositionDescriptionStatus(true);
    });
}
